export default function () {
  new Swiper(".supporters-slider__swiper", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: "auto",
      },
      1200: {
        spaceBetween: 40,
        slidesPerView: 5,
      },
    },
    navigation: {
      nextEl: ".supporters-slider__swiper__btn.next",
      prevEl: ".supporters-slider__swiper__btn.prev",
    },
    on: {
      init: function () {
        setSlideHeightsToMax(this);
      },
      resize: function () {
        setSlideHeightsToMax(this);
      },
    },
  });

  function setSlideHeightsToMax(swiper) {
    const slides = swiper.slides;
    let maxHeight = 0;
    let paddingAddition = 48;

    slides.forEach((slide) => {
      const content = slide.querySelector(".supporters-slider__team-member");
      if (content) {
        content.style.height = ""; // Reset height before recalculating
        const contentHeight = content.clientHeight + paddingAddition;
        maxHeight = Math.max(maxHeight, contentHeight);
      }
    });

    slides.forEach((slide) => {
      const content = slide.querySelector(".supporters-slider__team-member");
      if (content) {
        content.style.height = maxHeight + "px";
      }
    });
  }
}
